// extracted by mini-css-extract-plugin
module.exports = {"link":"_1oqFL","image":"_1xqQo","root":"_127Ot"};